import { useState, useEffect, useCallback } from 'react';
import { useCatalog } from './use-catalog';
import { BrandEntity } from '../../../domain/entities/brand.entity';

export const useBrands = (activeOnly: boolean = true) => {
  const { getBrandsUseCase } = useCatalog();
  const [brands, setBrands] = useState<BrandEntity[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchBrands = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getBrandsUseCase.execute({ activeOnly });
      setBrands(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar marcas');
    } finally {
      setLoading(false);
    }
  }, [getBrandsUseCase]);

  useEffect(() => {
    fetchBrands();
  }, [fetchBrands]);

  return {
    brands,
    loading,
    error,
    refetch: fetchBrands,
  };
};
